import React from "react";

/**
 * Mini chart-shape glyphs for the catalogue rail — one per chart shape, not
 * per graph. Drawn with currentColor throughout so they invert cleanly when a
 * rail item is selected and its text flips to cream on dark green.
 *
 * Shapes: bars | line | scatter | combo
 */

const VIEW_BOX = "0 0 44 20";
const SIZE = { width: 44, height: 20, flex: "none" };

const Bars = () => (
  <g fill="currentColor">
    <rect x="1" y="11" width="6" height="9" rx="1" />
    <rect x="10" y="7" width="6" height="13" rx="1" />
    <rect x="19" y="13" width="6" height="7" rx="1" />
    <rect x="28" y="4" width="6" height="16" rx="1" />
    <rect x="37" y="9" width="6" height="11" rx="1" />
  </g>
);

const Line = () => (
  <polyline
    points="2,15 12,7 22,12 32,4 42,9"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
);

const Scatter = () => (
  <g>
    <line
      x1="3"
      y1="17"
      x2="41"
      y2="4"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeDasharray="3 2"
      opacity="0.6"
    />
    <g fill="currentColor">
      <circle cx="9" cy="15" r="2" />
      <circle cx="19" cy="12" r="2" />
      <circle cx="28" cy="9" r="2" />
      <circle cx="37" cy="6" r="2" />
    </g>
  </g>
);

const Combo = () => (
  <g>
    <g fill="currentColor" opacity="0.55">
      <rect x="2" y="10" width="7" height="10" rx="1" />
      <rect x="12" y="14" width="7" height="6" rx="1" />
      <rect x="22" y="6" width="7" height="14" rx="1" />
      <rect x="32" y="11" width="7" height="9" rx="1" />
    </g>
    <polyline
      points="5.5,7 15.5,11 25.5,5 35.5,9"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </g>
);

const SHAPES = {
  bars: Bars,
  line: Line,
  scatter: Scatter,
  combo: Combo,
};

function GraphGlyph({ shape }) {
  const Shape = SHAPES[shape] || Bars;
  return (
    <svg viewBox={VIEW_BOX} style={SIZE} aria-hidden="true" focusable="false">
      <Shape />
    </svg>
  );
}

export default GraphGlyph;
